'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var Cell_web_styles = require('./Cell.web.styles.cjs');

/**
 * Used for highlighting important blocks of information
 *
 * @scope Core
 */ const Cell = ({ isMarginless = false, backgroundColor = "system", isFullWidth = true, children, customCss, ...rest })=>{
    const cellStyles = [
        Cell_web_styles.cell,
        isMarginless && Cell_web_styles.marginless,
        Cell_web_styles.background[backgroundColor],
        isFullWidth && Cell_web_styles.fullWidth,
        customCss
    ];
    return /*#__PURE__*/ jsxRuntime.jsx("div", {
        css: cellStyles,
        "data-testid": "aviary-cell",
        ...rest,
        children: children
    });
};

exports.Cell = Cell;
//# sourceMappingURL=Cell.web.cjs.map
